export default __webpack_public_path__ + "static/media/Binh Nguyen.df0f786d.png";